import Contact from '../components/Contact';

const ContactPage = () => {
    return (
        <div className="pt-20">
            <Contact />
        </div>
    );
};

export default ContactPage;